import { saveConfig } from './config';

// 定数定義
const BREAKPOINTS = {
    mobile: '(max-width: 767.98px)',
    tablet: '(min-width: 768px) and (max-width: 991.98px)',
    desktop: '(min-width: 992px)'
};

const SIDENAV_SIZES = {
    DEFAULT: 'default',
    FULL: 'full',
    FULLSCREEN: 'fullscreen',
    CONDENSED: 'condensed',
    COMPACT: 'compact',
    SM_HOVER: 'sm-hover'
};

const html = document.getElementsByTagName('html')[0];

// レイアウト操作の主要機能
const layoutManager = {
    // サイドナビの状態更新
    updateSidenavSize(size, shouldSave = true) {
        const currentSize = html.getAttribute('data-sidenav-size');
        
        // 同じサイズの場合は処理をスキップ
        if (currentSize === size) return;

        html.setAttribute('data-sidenav-size', size);

        if (shouldSave) {
            window.config.sidenav.size = size;
            saveConfig(window.config);
        }
    },

    // レイアウトモードの更新
    updateLayoutMode(mode, shouldSave = true) {
        html.setAttribute('data-layout-mode', mode);
        if (shouldSave) {
            window.config.layout.mode = mode;
            saveConfig(window.config);
        }
    },

    // レスポンシブ対応のサイドバー処理
    handleResponsiveSidebar: {
        mobile() {
            layoutManager.updateSidenavSize(SIDENAV_SIZES.FULL, false);
            html.classList.remove('sidebar-enable');
            layoutManager.backdrop.hide();
        },

        tablet() {
            const { size } = window.config.sidenav;
            if (size !== SIDENAV_SIZES.FULL && size !== SIDENAV_SIZES.FULLSCREEN) {
                layoutManager.updateSidenavSize(SIDENAV_SIZES.DEFAULT, false);
            }
            html.classList.remove('sidebar-enable');
            layoutManager.backdrop.hide();
        },

        desktop() {
            const { size } = window.config.sidenav;
            layoutManager.updateSidenavSize(size, false);
            layoutManager.updateLayoutMode(window.config.layout.mode, false);
            html.classList.remove('sidebar-enable');
            layoutManager.backdrop.hide();
        }
    },

    // サイドナビの切り替え
    toggleSidenav(mode) {
        const currentSize = html.getAttribute('data-sidenav-size');
        const isDesktop = window.matchMedia(BREAKPOINTS.desktop).matches;
        
        
        if (mode === 'full') {
            if (isDesktop) {
                // デスクトップモードの場合
                if (currentSize === SIDENAV_SIZES.DEFAULT) {
                    // デフォルト状態から非表示に
                    this.updateSidenavSize(SIDENAV_SIZES.FULL, true);
                    html.classList.remove('sidebar-enable');
                    this.backdrop.hide();
        
                } else {
                    // 非表示状態からデフォルトに戻す
                    this.updateSidenavSize(SIDENAV_SIZES.DEFAULT, true);
                    html.classList.add('sidebar-enable');
                    this.backdrop.hide();
                }
            } else {
                // タブレット・モバイルモードの場合
                html.classList.toggle('sidebar-enable');
                if (html.classList.contains('sidebar-enable')) {
                    this.updateSidenavSize(SIDENAV_SIZES.FULL, true);
                } else {
                    this.updateSidenavSize(SIDENAV_SIZES.DEFAULT, true);
                }
            }
        } else if (mode === 'fullscreen') {
            const configSize = window.config.sidenav.size;
            const newSize = currentSize === SIDENAV_SIZES.FULLSCREEN 
                ? (configSize === SIDENAV_SIZES.FULLSCREEN ? SIDENAV_SIZES.DEFAULT : configSize)
                : SIDENAV_SIZES.FULLSCREEN;
            this.updateSidenavSize(newSize, true);
        }
    },

    // バックドロップ制御
    backdrop: {
        enabled() {
            return html.classList.contains('sidebar-enable');
        },
        show(size) {
        
            html.classList.add('sidebar-enable');
            if (size === SIDENAV_SIZES.FULL) {
                const backdrop = document.createElement('div');
                backdrop.id = 'custom-backdrop';
                backdrop.className = 'offcanvas-backdrop fade show';
                document.body.appendChild(backdrop);
                document.body.style.overflow = 'hidden';
                
                if (window.innerWidth > 767) {
                    document.body.style.paddingRight = '15px';
                }
                backdrop.addEventListener('click', () => {
                    this.hide();
                    layoutManager.updateSidenavSize(SIDENAV_SIZES.DEFAULT, true);
                });
            }
           
        },
        
        hide() {
            html.classList.remove('sidebar-enable');
            const backdrop = document.getElementById('custom-backdrop');
            if (backdrop) {
                backdrop.remove();
                document.body.style.overflow = null;
                document.body.style.paddingRight = null;
            }
        }
    }
};

// トグルボタンの初期化
function initToggleButtons() {
    const handlers = {
        'toggle': () => {
            layoutManager.toggleSidenav('full');
        },
        'mobile-toggle': () => {
            if(layoutManager.backdrop.enabled()) {
                layoutManager.backdrop.hide();
            } else {
                layoutManager.backdrop.show(SIDENAV_SIZES.FULL);
            }
        },
        'close-full': () => {
            layoutManager.updateSidenavSize(SIDENAV_SIZES.DEFAULT, true);
            html.classList.remove('sidebar-enable');
            layoutManager.backdrop.hide();
        },
        'hover-toggle': () => {
            const currentSize = html.getAttribute('data-sidenav-size');
            layoutManager.updateSidenavSize(
                currentSize === SIDENAV_SIZES.DEFAULT ? SIDENAV_SIZES.FULL : SIDENAV_SIZES.DEFAULT,
                true
            );
        }
    };

    document.querySelectorAll('[data-action]').forEach(element => {
        const handler = handlers[element.dataset.action];
        if (handler) {
            element.addEventListener('click', handler);
        }
    });
}

// レイアウトの初期化
export function initLayout() {
    if (window.matchMedia) {
        Object.entries(BREAKPOINTS).forEach(([device, query]) => {
            const mediaQuery = window.matchMedia(query);
            const handler = (e) => {
                if (e.matches) {
                    layoutManager.handleResponsiveSidebar[device]();
                }
            };
            mediaQuery.addEventListener('change', handler);
            handler(mediaQuery);
        });
    } else {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width <= 767.98) layoutManager.handleResponsiveSidebar.mobile();
            else if (width <= 991.98) layoutManager.handleResponsiveSidebar.tablet();
            else layoutManager.handleResponsiveSidebar.desktop();
        };
        
        window.addEventListener('resize', handleResize);
        handleResize();
    }

    initToggleButtons();
}